import { Box, Button, makeStyles } from '@material-ui/core';
import React, { FC } from 'react';

import { useDispatch } from 'react-redux';

import colorRectangle from 'src/images/colorRectangle.png';
import { RootState, useSelector } from 'src/store';

interface editTextProps {
  menuTitle: string;
  type: string;
}

const useStyles = makeStyles(() => ({
  root: {
    padding: '1.5rem 1rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem'
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden',
    border: '1px solid #dddddd'
  },
  fontBox: {
    width: '100%',
    height: '2.5rem',
    padding: '0.5rem',

    cursor: 'pointer',
    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400,

    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: '1px solid #D9D9D9'
  },
  input: {
    height: '4.5rem',
    padding: '0.5rem',
    outline: 'none',
    overflow: 'hidden',

    '&:focus': {
      border: 0,
      outline: 'none'
    },

    border: '1px solid #dddddd'
  },
  inputRoot: {
    padding: 0,
    height: '100%',
    display: 'block'
  },
  inputText: {
    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: '1.2rem',
    letterSpacing: '0.015rem'
  },

  bottomBtn: {
    padding: '0.5rem',
    display: 'flex',
    justifyContent: 'space-between',
    border: '1px solid #dddddd',
    backgroundColor: '#F2F2F2'
  },
  btnMinusPlus: {
    maxWidth: '1.5rem',
    minWidth: '1.5rem',
    maxHeight: '1.5rem',
    minHeight: '1.5rem',
    padding: 0,
    display: 'flex'
  },

  fontNumber: {
    width: '3rem',
    height: '1.5rem',

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400,

    borderRadius: '0.25rem',
    border: '1px solid #D9D9D9',
    backgroundColor: '#fff'
  },

  buttonWrapper: {
    maxWidth: '1.5rem',
    minWidth: '1.5rem',
    maxHeight: '1.5rem',
    minHeight: '1.5rem'
  },
  buttonImage: {
    maxWidth: '1.5rem',
    minWidth: '1.5rem',
    maxHeight: '1.5rem',
    minHeight: '1.5rem'
  },

  boxWrapper: {
    // margin: '0 0.5rem',
    display: 'flex',
    justifyContent: 'space-between'
  },
  colorBox: {
    padding: '0.25rem 0.5rem',
    borderRadius: '0.25rem',
    border: '1px solid #D9D9D9',
    textAlign: 'center',

    color: '#000',
    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400
  },
  textAlign: {
    cursor: 'pointer'
  }
}));

export const MultiBgColor: FC<any> = ({ type, picker }) => {
  const classes = useStyles();

  let currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  let bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);

  const handleColorPicker = () => {
    picker.setIsComponentVisible(!picker.isComponentVisible);
  };

  return (
    <>
      <Box className={classes.boxWrapper}>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <Button
            ref={picker.refButton1}
            onClick={handleColorPicker}
            className={classes.buttonWrapper}
          >
            <img
              alt="color"
              src={colorRectangle}
              className={classes.buttonImage}
            />
          </Button>
          <Button
            ref={picker.refButton2}
            style={{
              maxWidth: '1.25rem',
              minWidth: '1.25rem',
              maxHeight: '1.25rem',
              minHeight: '1.25rem',
              padding: 0
            }}
            onClick={handleColorPicker}
          >
            <div
              style={{
                width: '1.25rem',
                height: '1.25rem',
                backgroundColor: bgColor?.[type]?.[currentIndex],
                border: `1px solid #D9D9D9`,
                borderRadius: 999
              }}
            />
          </Button>

          <div className={classes.colorBox}>
            {bgColor?.[type]?.[currentIndex]?.toUpperCase()}
          </div>
        </div>
        {/* <div className={classes.colorBox}>100%</div> */}
      </Box>
    </>
  );
};

const EditMultiBgColor = () => {
  return <></>;
};

export default EditMultiBgColor;
